import React from 'react';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { TAG_GROUP_KIND } from '../../../../../../constants/service/app/tagConstants';
import { setExcelBulkEditProduct, setIsExcelBulkEditProductInvalid } from '../../../../../../lib/utils/productUtils';

/**
 *  엑셀 상품 일괄 편집 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: '순번',
      dataIndex: 'no',
      render: (value, record) => {
        return {
          children: value,
          props: {
            rowSpan: record.no ? record.optionSize : 0,
          },
        };
      },
    },
    {
      title: '편집 가능',
      dataIndex: 'available',
      filters: [
        {
          text: '가능',
          value: true,
        },
        {
          text: '불가능',
          value: false,
        },
      ],
      onFilter: (value, record) => value === record.available,
      render: (value, record) => {
        return {
          children: value ? <div className="valid">가능</div> : <div className="invalid">불가능</div>,
          props: {
            rowSpan: record.no ? record.optionSize : 0,
          },
        };
      },
    },
    {
      title: '상품번호',
      dataIndex: 'id',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '카테고리',
      dataIndex: 'category',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '판매상태',
      dataIndex: 'status',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '상품명',
      dataIndex: 'name',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '판매가(원)',
      dataIndex: 'originPrice',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value, ''),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '할인 단위',
      dataIndex: 'discountTypeUnit',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '할인값',
      dataIndex: 'discountValue',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value, ''),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '할인 시작일',
      dataIndex: 'discountStartDate',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value, undefined, DATE_FORMAT.YMD_DASH_FORMAT),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '할인 종료일',
      dataIndex: 'discountEndDate',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value, undefined, DATE_FORMAT.YMD_DASH_FORMAT),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '재고 수량',
      dataIndex: 'stockCount',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value, ''),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '제품번호',
      dataIndex: 'number',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '상품옵션 분류',
      dataIndex: 'optionType',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '상품 옵션',
      children: [
        {
          title: '옵션명',
          dataIndex: 'optionName',
          render: (value, record) => ({
            children: record.optionList ? setExcelBulkEditProduct(record.optionList) : setExcelBulkEditProduct(value),
            props: {
              className: record.optionList
                ? setIsExcelBulkEditProductInvalid(record.optionList)
                : setIsExcelBulkEditProductInvalid(value),
              colSpan: record.optionList ? 5 : 1,
            },
          }),
        },
        {
          title: '옵션가',
          dataIndex: 'optionPrice',
          render: (value, record) => ({
            children: record.optionList
              ? setExcelBulkEditProduct(record.optionList)
              : setExcelBulkEditProduct(value, ''),
            props: {
              className: setIsExcelBulkEditProductInvalid(value),
              colSpan: record.optionList ? 0 : 1,
            },
          }),
        },
        {
          title: '재고수량',
          dataIndex: 'optionStockCount',
          render: (value, record) => ({
            children: record.optionList
              ? setExcelBulkEditProduct(record.optionList)
              : setExcelBulkEditProduct(value, ''),
            props: {
              className: setIsExcelBulkEditProductInvalid(value),
              colSpan: record.optionList ? 0 : 1,
            },
          }),
        },
        {
          title: '판매상태',
          dataIndex: 'optionStatus',
          render: (value, record) => ({
            children: record.optionList ? setExcelBulkEditProduct(record.optionList) : setExcelBulkEditProduct(value),
            props: {
              className: setIsExcelBulkEditProductInvalid(value),
              colSpan: record.optionList ? 0 : 1,
            },
          }),
        },
        {
          title: '제품번호',
          dataIndex: 'optionNumber',
          render: (value, record) => ({
            children: record.optionList ? setExcelBulkEditProduct(record.optionList) : setExcelBulkEditProduct(value),
            props: {
              className: setIsExcelBulkEditProductInvalid(value),
              colSpan: record.optionList ? 0 : 1,
            },
          }),
        },
      ],
    },
    {
      title: '실판매가',
      dataIndex: 'salesPrice',
      render: (value, record) => {
        const actualPrice =
          Number.isInteger(value) && Number.isInteger(record.optionPrice) ? value + record.optionPrice : value;

        return {
          children: setExcelBulkEditProduct(actualPrice, ''),
          props: {
            className: setIsExcelBulkEditProductInvalid(value),
          },
        };
      },
    },
    {
      title: '상품 컨셉 태그',
      dataIndex: TAG_GROUP_KIND.CONCEPT,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '아이템 태그',
      dataIndex: TAG_GROUP_KIND.ITEM,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '귀걸이 착용방법이 침인 경우',
      dataIndex: 'needPierce',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '귀걸이 착용방법이 귀찌인 경우',
      dataIndex: 'needNotPierce',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '소재/귀걸이침 태그',
      dataIndex: TAG_GROUP_KIND.MATERIAL_POST_EARRING,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '소재/베이스 태그',
      dataIndex: TAG_GROUP_KIND.MATERIAL_BASE,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '소재/기타 태그',
      dataIndex: TAG_GROUP_KIND.MATERIAL_ETC,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '귀금속 장신구',
      dataIndex: 'isExpensive',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '소재/도금 태그',
      dataIndex: TAG_GROUP_KIND.MATERIAL_PLATING,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '소재/스톤 태그',
      dataIndex: TAG_GROUP_KIND.MATERIAL_STONE,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '컬러/패턴 태그',
      dataIndex: TAG_GROUP_KIND.COLOR_PATTERN,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '모양 태그',
      dataIndex: TAG_GROUP_KIND.SHAPE,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '시즌/상황 태그',
      dataIndex: TAG_GROUP_KIND.SEASON_STATUS,
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '사이즈',
      dataIndex: 'size',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '중량',
      dataIndex: 'weight',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '구매 시 유의 사항',
      dataIndex: 'notice',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '주문 메시지',
      dataIndex: 'orderExampleMessage',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '배송 타입',
      dataIndex: 'deliveryType',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '주문시 제작 소요일',
      dataIndex: 'orderMadeDate',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '바로 배송 기준 시간',
      dataIndex: 'directDeliveryTimeLimit',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: 'A/S 안내',
      dataIndex: 'asInform',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '착용시 주의 사항',
      dataIndex: 'caution',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '품질보증 기준',
      dataIndex: 'qualityAssurance',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '제조자',
      dataIndex: 'manufacturer',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
    {
      title: '제조국',
      dataIndex: 'origin',
      render: (value, record) => ({
        children: setExcelBulkEditProduct(value),
        props: {
          className: setIsExcelBulkEditProductInvalid(value),
          rowSpan: record.no ? record.optionSize : 0,
        },
      }),
    },
  ];
};
